// extracted by mini-css-extract-plugin
export default {"Badge":"Badge_Badge__k5XWg"};